'use strict';

const $ = require('dibs-jquery-shim');
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const CheckmarkIcon = require('dibs-vg/dist/react/checkmark');
const ArrowDownIcon = require('dibs-vg/dist/react/arrow-down');
const ContextComponent = require('../../global/components/ContextComponent');

const { connectToStores } = require('fluxible-addons-react');
const currencies = require('dibs-currency-helpers/currencies');
const getCurrencySymbol = require('dibs-currency-helpers/getCurrencySymbol');
const root = require('bunsen/helpers/windowCheck');

const UserStore = require('../../global/stores/UserStore.es');
const currencyActions = require('../../global/actions/currencyActions');
const CurrencyLocalization = require('../../user/CurrencyLocalization');
const currencyLocalizer = new CurrencyLocalization({ $el: $(document.body) });

const currencySelectTracking = require('./currencySelect-tracking');

const style = require('./CurrencySelect-style.scss');

class CurrencySelect extends ContextComponent {
    constructor(props) {
        super(props);

        this.state = {
            showTooltip: false,
        };

        this._onClick = this._onClick.bind(this);
        this._handleOpen = this._handleOpen.bind(this);
        this._handleClose = this._handleClose.bind(this);
    }

    componentWillMount() {
        root.addEventListener('click', this._handleClose);
    }

    componentWillUnmount() {
        root.removeEventListener('click', this._handleClose);
    }

    _onClick(event) {
        const { value: currency } = event.currentTarget.dataset;

        event.preventDefault();
        this.context.executeAction(currencyActions.updateUserCurrency, { currency });
        this.context.executeAction(currencySelectTracking.fireCurrencyUpdateTracking, { currency });
        currencyLocalizer.updatePrices(true, currency);

        this._handleClose();
    }

    _handleOpen(event) {
        event.stopPropagation();
        this.setState({ showTooltip: true });
    }

    _handleClose() {
        this.setState({ showTooltip: false });
    }

    _getDropdown() {
        const { currentCurrency, dataTn } = this.props;

        return (
            <div className={style.currencyList}>
                {currencies.map(currency => {
                    const symbol = getCurrencySymbol(currency);
                    const checkmarkClass = classNames(style.checkmark, {
                        [style.isActive]: currentCurrency === currency,
                    });

                    return (
                        <a
                            className={style.currencyLink}
                            href="#"
                            onClick={this._onClick}
                            data-value={currency}
                            data-tn={`${dataTn}-link-${currency.toLowerCase()}`}
                            key={currency}
                        >
                            <CheckmarkIcon className={checkmarkClass} />
                            <span className={style.currencySymbol}>{symbol}</span>
                            {currency}
                        </a>
                    );
                })}
            </div>
        );
    }

    render() {
        const { currentCurrency } = this.props;
        const symbol = getCurrencySymbol(currentCurrency);
        const dropdownClass = classNames(style.dropdownWrapper, {
            'is-hidden': !this.state.showTooltip,
        });

        return (
            <div className={style.currencyWrap}>
                <div
                    className={style.currency}
                    ref="currency"
                    onClick={this._handleOpen}
                    data-tn="selected-currency"
                >
                    <span className={style.currencySymbol}>{symbol}</span>
                    {currentCurrency}
                    <ArrowDownIcon className={style.arrowDown} />
                </div>
                <div className={dropdownClass}>{this._getDropdown()}</div>
            </div>
        );
    }
}

CurrencySelect.propTypes = {
    currentCurrency: PropTypes.string.isRequired,
    dataTn: PropTypes.string,
};

CurrencySelect = connectToStores(CurrencySelect, [UserStore], context => {
    const userStore = context.getStore(UserStore);

    return {
        currentCurrency: userStore.getCurrency(),
    };
});

module.exports = CurrencySelect;



// WEBPACK FOOTER //
// ./assets/js/components/CurrencySelect/CurrencySelect.jsx